import { useParams } from "@/lib/router"

export function useCurrentProjectId() {
	const { id } = useParams()

	return parseInt(id as string)
}
